import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import clubInfo from "../club_info.json"
import EstacionamientoSmallHeader from "./Estacionamientos/EstacionamientoSmallHeader";



const EstacionamientoPpal = () => {
    const navigate = useNavigate();
   
    
    return (
        <>
        <main>
      <div class="container text-center mainContent" >
      <EstacionamientoSmallHeader texto="" retorno="/"/>
              {/*<PageTitlesBig texto="Clubes Municipales"  icono="./icon_header_clubes.svg" retorno="/actividades" subtexto={"Club "+localStorage.getItem("Actividad-Club")}/>*/}
    
    <div class="row" style={{paddingTop:"30px"}}>
        <div class="col-12 alignCenter textGreyTitle">
        ¿D&oacute;nde estacionaste?
        </div>
        </div>
        <div class="row">
            <div class="col-12">

            </div>
        </div>
        <div className="row">
            <div className="col-5" style={{textAlign:"right"}}>
                <div className="row" >
                    <div className="col">
            <img src="./estacionamiento_ppal_call.svg" width="172px" style={{marginLeft:"34px"}}/>
            </div>
            </div>
            <div className="row">
                <div className="col">

            <div className="buttonContainerSpec">
                        <button className="buttonMicroClipFixed"
                        onClick={()=>navigate("/estacionamiento")}
                        >calle</button>
                    </div>
                    </div>
                    </div>
            </div>
    
        <div className="col-2">
            <img src="./img-vert.png" />
        </div>
        <div className="col-5" style={{textAlign:"left"}}>

        <img src="./estacionamiento_ppal_play.svg" width="100px"/>

        <div className="buttonContainerSpec">
                        <button className="buttonMicroClipFixed"
                        onClick={()=>navigate("/estacionamientodonde")}>play&oacute;n</button>
                    </div>
        </div>
        </div>
        <div className="row">
            <div className="col">
                <div className="buttonContainer">
                
                <button className="buttonSemiHighClip buttonGreyClipSpec botonDebajo"
                onClick={()=>navigate("/estacionamientomapasbis")}>
                <img className="buttonCreditImageSpec" src="./estacionamiento_ppal_lupa.svg"/>
                    ¿Busc&aacute;s lugar?</button>
                </div>
            </div>
        </div>
        
</div>
</main>
        
        </>

    );
    }
export default EstacionamientoPpal;